import React from 'react'
import EulaEN from './EulaEN'
import EulaPT from './EulaPT'
import EulaRU from './EulaRU'
import EulaZH from './EulaZH'
import EulaVN from './EulaVN'
import EulaID from './EulaID'
import BackLink from '../ui/buttons/BackLink'
import { Helmet } from "react-helmet"

const content = () => {
  let html;

  switch(window.COUNTRY) {
    case 'RU':
      html = EulaRU;
      break;
    case 'ID':
      html = EulaID;
      break;
    case 'VN':
      html = EulaVN;
      break;
    case 'CN':
      html = EulaZH;
      break;
    case 'BR':
      html = EulaPT;
      break;
    default:
      html = EulaEN;
  }

  return { __html: html };
}

const title = () => {
  return {
    CN: '《使用协议》',
    BR: 'Acordo de usuário',
    RU: 'Олимпиада BRICSMATH для учеников 1–11 классов'
  }[window.COUNTRY] || 'Terms of use - Competition "BRICSMATH"'
}

const Eula = (props) => {
  return (
    <div className="static">
      <Helmet>
        <title>{ title() }</title>
      </Helmet>
      <BackLink />
      <div dangerouslySetInnerHTML={ content() } />
    </div>
  )
}

export default Eula
